var e=(r,t)=>Intl.NumberFormat("en-US",{style:"currency",currency:"USD",maximumFractionDigits:0,...t}).format(r);export{e as a};
